import { addLog } from 'assets/components/feedback/Feedback';
import useApi from 'assets/hooks/api/useApi';
import { HttpStatus } from 'config/Api.Config';
import productPricingAutomationRuleDeleteApi from 'models/productManagement/productPricingAutomationRule/delete/Api.ProductPricingAutomationRule.Delete';
import VehicleClass from 'models/productManagement/vehicleClass/Model.VehicleClass';
import VehicleMake from 'models/productManagement/vehicleMake/Model.VehicleMake';
import VehicleModel from 'models/productManagement/vehicleModel/Model.VehicleModel';
import AutomationRulesTable from 'module/automation/components/Automation.Rule.Table';
import { createPricingAutomationSchema } from 'module/automation/schemas/PricingAutomationSchema';
import { useProductProvider } from '../../Product.Hooks';

const ProductEditPricingAutomationRules = () => {
  const { form, productPricingAutomationRuleListApi } = useProductProvider();
  const rules = form.data.productPricingAutomationRules || [];

  const vehicleMakeApi = useApi({
    action: VehicleMake.list,
    wait: false,
    keepResponse: true,
  });
  const vehicleModelApi = useApi({
    action: VehicleModel.list,
    wait: false,
    keepResponse: true,
  });
  const vehicleClassApi = useApi({
    action: VehicleClass.list,
    wait: false,
    keepResponse: true,
  });

  const schema = createPricingAutomationSchema({
    vehicleMakes: vehicleMakeApi?.payload?.data,
    vehicleModels: vehicleModelApi?.payload?.data,
    vehicleClasses: vehicleClassApi?.payload?.data,
    subfees: form.data?.subfee,
    apiCallbacks: {
      onMakeCodeChange: (value) => {
        vehicleModelApi.execute((body) => ({
          ...body,
          vehicleMakeCodeId: !value
            ? undefined
            : [vehicleMakeApi?.payload?.data?.find((it) => it.makeCode === value)?.id],
        }));
      },
      onModelChange: (value) => {
        vehicleClassApi.execute((body) => ({
          ...body,
          vehicleModelId: !value ? undefined : [vehicleModelApi?.payload?.data?.find((it) => it.code === value)?.id],
        }));
      },
    },
  });

  const deleteRule = async (ruleId?: number) => {
    if (!ruleId || ruleId < 1) return;

    const res = await productPricingAutomationRuleDeleteApi(ruleId);
    if (res.status !== HttpStatus.ok) {
      addLog({ error: res.message });
    }
    productPricingAutomationRuleListApi.execute((body) => body);
  };

  return (
    <AutomationRulesTable<Model.IProductPricingAutomationRule>
      value={rules as Model.IProductPricingAutomationRule[]}
      schema={schema}
      onChange={(updatedRules) => form.update({ productPricingAutomationRules: updatedRules })}
      onDeleteRule={(_, rule) => deleteRule(rule?.id)}
    />
  );
};

export default ProductEditPricingAutomationRules;
